import * as React from "react"
import { Lock, Eye, EyeOff } from "lucide-react"
import { cn } from "@/lib/utils"

const PasswordInput = React.forwardRef<
  HTMLInputElement,
  Omit<React.ComponentProps<"input">, "type">
>(({ className, ...props }, ref) => {
  const [reveal, setReveal] = React.useState(false)
  const show = () => setReveal(true)
  const hide = () => setReveal(false)

  return (
    <div className="relative">
      <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <input
        ref={ref}
        type={reveal ? "text" : "password"}
        className={cn(
          "w-full h-12 pl-11 pr-11 bg-muted rounded-md text-foreground placeholder:text-muted-foreground text-sm outline-none border border-transparent focus:border-border transition-colors",
          className
        )}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        aria-label={reveal ? "Hide password" : "Show password"}
        onMouseDown={(e) => {
          e.preventDefault()
          show()
        }}
        onMouseUp={hide}
        onMouseLeave={hide}
        onTouchStart={show}
        onTouchEnd={hide}
        onTouchCancel={hide}
        onContextMenu={(e) => e.preventDefault()}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
      >
        {reveal ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  )
})
PasswordInput.displayName = "PasswordInput"

export { PasswordInput }
